<div class="quote-shell container py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10">
      <div class="quote-card">
        <!-- HEADER -->
        <div class="quote-head d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div class="d-flex align-items-center gap-3">
            <img class="brand-logo" src="assets/logo-sami.png" alt="Logo SAMI Pulizie" loading="lazy" />
            <div>
              <h2 class="m-0">Richiedi un preventivo</h2>
              <p class="m-0 text-muted small">
                Lascia i tuoi recapiti: la sede scelta ti ricontatterà per concordare il servizio. Sopralluogo gratuito e senza impegno.
              </p>
            </div>
          </div>

          <div class="quote-badges d-flex gap-2 flex-wrap justify-content-md-end">
            <span class="badge-soft badge-blue"><i class="fa-solid fa-shield-halved me-1"></i> Professionisti</span>
            <span class="badge-soft badge-pink"><i class="fa-solid fa-bolt me-1"></i> Rapidi</span>
            <span class="badge-soft badge-dark"><i class="fa-solid fa-check me-1"></i> Preventivo gratuito</span>
          </div>
        </div>

        <hr class="my-3" />

        <!-- FORM -->
        <form (ngSubmit)="onSubmit(preventiviForm)" #preventiviForm="ngForm" novalidate>
          <div class="row g-3">

            <div class="col-12">
              <label class="form-label" for="sede">Sede di riferimento *</label>
              <select
                class="form-select"
                [class.is-invalid]="sede.invalid && (sede.dirty || sede.touched)"
                id="sede"
                name="sede"
                [(ngModel)]="formData.sede"
                required
                #sede="ngModel"
              >
                <option value="" disabled>Scegli Pescara o Giulianova</option>
                <option value="pescara">Pescara e provincia</option>
                <option value="teramo">Giulianova e provincia di Teramo</option>
              </select>
              <div class="invalid-feedback">Seleziona Pescara o Teramo per inviare la richiesta alla sede corretta.</div>
              <div class="form-text" *ngIf="formData.sede === 'pescara'">
                La richiesta sarà gestita dalla sede di Pescara: info&#64;samipulizie.it
              </div>
              <div class="form-text" *ngIf="formData.sede === 'teramo'">
                La richiesta sarà gestita dalla sede di Giulianova: commerciale.te&#64;samipulizie.it
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="nome">Nome *</label>
              <input
                class="form-control"
                [class.is-invalid]="nome.invalid && (nome.dirty || nome.touched)"
                type="text"
                id="nome"
                name="nome"
                autocomplete="given-name"
                [(ngModel)]="formData.nome"
                required
                minlength="2"
                #nome="ngModel"
                placeholder="Es. Mario"
              />
              <div class="invalid-feedback">Inserisci un nome valido.</div>
            </div>

            <div class="col-12">
              <label class="form-label" for="indirizzo">Comune / Zona *</label>
              <input
                class="form-control"
                [class.is-invalid]="indirizzo.invalid && (indirizzo.dirty || indirizzo.touched)"
                type="text"
                id="indirizzo"
                name="indirizzo"
                [(ngModel)]="formData.indirizzo"
                required
                minlength="2"
                #indirizzo="ngModel"
                placeholder="Es. Pescara centro oppure Giulianova"
              />
              <div class="invalid-feedback">Inserisci un comune o una zona valida.</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="email">Email *</label>
              <input
                class="form-control"
                [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
                type="email"
                id="email"
                required
                name="email"
                autocomplete="email"
                [(ngModel)]="formData.email"
                email
                samiRealEmail
                [ngModelOptions]="{ updateOn: 'blur' }"
                #email="ngModel"
                placeholder="nome@email.it"
              />
              <div class="form-text">Qui riceverai la conferma della richiesta.</div>
              <div class="invalid-feedback" *ngIf="email.errors?.['providerTypo']">
                Il dominio sembra errato. Intendevi {{ email.errors?.['providerTypo'].suggestion }}?
              </div>
              <div class="invalid-feedback" *ngIf="email.errors?.['emailDomainMissing']">
                Questo dominio email non risulta esistente. Controlla l’indirizzo.
              </div>
              <div class="invalid-feedback" *ngIf="email.errors?.['required'] || email.errors?.['email']">
                Inserisci un’email valida.
              </div>
              <div class="form-text" *ngIf="email.pending">Verifica del dominio email…</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="telefono">Telefono *</label>
              <input
                class="form-control"
                [class.is-invalid]="telefono.invalid && (telefono.dirty || telefono.touched)"
                type="tel"
                id="telefono"
                name="telefono"
                autocomplete="tel"
                [(ngModel)]="formData.telefono"
                required
                minlength="8"
                #telefono="ngModel"
                placeholder="Es. 351 503 4934"
              />
              <div class="invalid-feedback">Inserisci un numero valido.</div>
            </div>

            <div class="col-12">
              <label class="form-label" for="servizio">Servizio richiesto *</label>
              <select class="form-select" id="servizio" name="servizio" [(ngModel)]="formData.servizio" required>
                <option value="" disabled>Di quale pulizia hai bisogno?</option>
                <option>Condomini</option><option>Uffici e aziende</option>
                <option>Abitazioni</option><option>Pulizie straordinarie / post ristrutturazione</option>
                <option>Sanificazioni</option><option>Palestre</option>
                <option>Cucine industriali / laboratori</option><option>Altro / da valutare insieme</option>
              </select>
            </div>

            <div class="col-12">
              <label class="form-label" for="descrizione">Altri dettagli (facoltativi)</label>
              <textarea
                class="form-control"
                [class.is-invalid]="descrizione.invalid && (descrizione.dirty || descrizione.touched)"
                id="descrizione"
                name="descrizione"
                [(ngModel)]="formData.descrizione"
                maxlength="4000"
                #descrizione="ngModel"
                rows="4"
                placeholder="Es. 80mq, 2 bagni, pulizia straordinaria post ristrutturazione..."
              ></textarea>
              <div class="invalid-feedback">Inserisci al massimo 4000 caratteri.</div>
              <div class="hint mt-1">Se vuoi, indica metratura, frequenza o esigenze particolari.</div>
            </div>

            <!-- PRIVACY -->
            <div class="col-12">
              <div class="privacy-row">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="privacy"
                  name="privacy"
                  name="privacy"
                  [(ngModel)]="privacyAccepted"
                  required
                />
                <label class="form-check-label" for="privacy">
                  Ho letto e accetto la
                  <a href="/privacy" (click)="openPrivacy($event)">Privacy Policy</a>
                </label>
              </div>
              <div class="small text-muted mt-1">
                I dati vengono usati solo per rispondere alla richiesta di preventivo.
              </div>
            </div>

            <!-- CTA -->
            <div class="col-12">
              <app-turnstile action="sami_quote" (tokenChange)="turnstileToken = $event" />
            </div>

            <div class="col-12 d-grid d-md-flex gap-2 justify-content-md-end mt-2">
              <button type="button" class="btn btn-outline-brand" (click)="resetForm(preventiviForm)" [disabled]="loading">
                Svuota
              </button>

              <button
                type="submit"
                class="btn btn-brand"
                [disabled]="preventiviForm.invalid || preventiviForm.pending || !privacyAccepted || !turnstileToken || loading"
              >
                <span *ngIf="!loading"><i class="fa-solid fa-paper-plane me-2"></i>Invia richiesta</span>
                <span *ngIf="loading"><i class="fa-solid fa-circle-notch fa-spin me-2"></i>Invio...</span>
              </button>
            </div>

            <div class="col-12" *ngIf="successMsg">
              <div class="alert alert-success mb-0" role="status" aria-live="polite">{{ successMsg }}</div>
            </div>

            <div class="col-12" *ngIf="errorMsg">
              <div class="alert alert-danger mb-0" role="alert">{{ errorMsg }}</div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PRIVACY -->
<div class="privacy-modal" *ngIf="showPrivacyModal" (click)="closePrivacy()">
  <div class="privacy-modal-content" (click)="$event.stopPropagation()">
    <div class="d-flex align-items-start justify-content-between gap-3">
      <h3 class="m-0">Informativa Privacy</h3>
      <button class="icon-btn" type="button" (click)="closePrivacy()" aria-label="Chiudi">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="policy-content mt-3">
      <p class="mb-2">
        Ai sensi del Regolamento UE 2016/679 (GDPR), i dati inseriti verranno trattati esclusivamente
        per elaborare la richiesta di preventivo e ricontattarti.
      </p>
      <ul class="mb-2">
        <li>Nessuna cessione a terzi.</li>
        <li>Conservazione limitata al tempo necessario alla gestione della richiesta.</li>
        <li>Titolare del trattamento: <strong>SAMI Pulizie</strong>.</li>
      </ul>
      <p class="mb-0">
        Puoi leggere l’informativa completa nella pagina <a href="/privacy" target="_blank" rel="noopener">Privacy Policy</a>.
      </p>
    </div>

    <button class="btn btn-brand w-100 mt-3" (click)="acceptPrivacy()">
      ACCETTO
    </button>
  </div>
</div>
